import React, { useEffect, useState } from 'react'
import { Link, withRouter } from 'react-router-dom'
import { Layout, Menu } from 'antd'
import { connect } from 'react-redux'
import UserCenter from './UserCenter'
import routesConfig from '../../../router/routes'
import { getAuth, storePermission } from '../../../utils/global'
import './index.less'

const { Header } = Layout

export interface GlobalHeaderProps {
	showMenu?: boolean;
}
const GlobalHeader: React.FC<any> = (props) => {
	const mainChildRoutes = routesConfig.find(item => item.path === '/main')?.routes?.map(item => {
		const filterRoutes: any[] = []
		item.routes && item.routes.forEach(route => {
			if (route.hiddenInMenu) return
			filterRoutes.push(route)
		})
		return {
			...item,
			routes: filterRoutes
		}
	})
	const [authPaths, setAuthPaths] = useState<string[]>([])
	const goHome = () => {
		props.history.push('/index')
	}
	useEffect(() => {
		if(props.userInfo.workid !== '') {
			if(props.userInfo.userType === 'IOCenter') {
				const permission = props.userInfo.permission.map(
					({ menuValue, menuName, menuType, ...rest }) => ({
						resourceVal: menuValue,
						nameCn: menuName,
						resourceType: Number(menuType),
						...rest,
					})
				)
				const { authMap } = storePermission(permission)
				setAuthPaths(authMap['route'].map(item => item.resourceVal))
			} else {
				getAuth('route').then(res => {
					if(res.length === 0) {
						// props.history.push('/403')
					} else {
						setAuthPaths(res.map(item => item.resourceVal))
					}
					console.log('get route auth: ', res)
				}) // 路由权限
			}
		} else {
			setAuthPaths([])
		}
	},[props.userInfo.workid])

	return (
		<Header className="global-header">
			<div className="logo" onClick={() => goHome()}></div>
			{props.showMenu && <Menu mode="horizontal" className="nav-menu" selectedKeys={[props.location.pathname]}>
				{ authPaths.length > 0 && <Menu.Item key="/">首页</Menu.Item>}
				{mainChildRoutes.map((route: any)=> {
					const { path, title, routes, redirect, exclude } = route
					if (!title) return
					if (!authPaths.includes(path)) return
					if (routes && routes.length) { // 子路由
						return (
							<Menu.SubMenu key={path} title={title} popupClassName="nav-menu-submenu">
								{routes.map(route => {
									const { path, title, redirect } = route
									const fullPath = redirect ? path + redirect : path
									return title && authPaths.includes(path) && (
										<Menu.Item key={fullPath}>
											<Link to={fullPath}>
												<span>{title}</span>
											</Link>
										</Menu.Item>
									)
								})}
							</Menu.SubMenu>
						)
					} else if (title && !exclude) {
						const fullPath = redirect ? path + redirect : path
						return (
							<Menu.Item key={fullPath}>
								<Link to={fullPath}>
									<span>{title}</span>
								</Link>
							</Menu.Item>
						)
					}
				})}
			</Menu>}
			<a className='global-auth' href='https://wf.17usoft.com/workflow/#/myApplication/formApply?modelKey=TTAllDFQManager' target='_blank'>权限申请</a>
			<UserCenter/>
		</Header>
	)
}

GlobalHeader.defaultProps = {
	showMenu: false,
}

function mapStateToProps(state) {
	return {
		userInfo: state.baseInfo.userInfo,
	}
}

export default connect(mapStateToProps)(withRouter(GlobalHeader))
